<template>
  <div class="filter-block__group">
    <div class="filter-block__text">{{ $t("Radius") }}</div>
    <vue-slider
      ref="slider"
      v-model="fieldValue"
      class="ui-slider"
      style="padding: 0"
      :tooltip="false"
      :dot-size="18"
      :height="3"
      :process-style="{
        backgroundColor: '#f95c4e',
      }"
      :min="field.min"
      :max="field.max"
    />
    <input v-model.number="fieldValue" type="number" class="form-control" />
  </div>
</template>

<script>
import { FieldMixin } from "stylemix-base";
import vueSlider from "vue-slider-component";

export default {
  name: "FormDistanceField",

  components: {
    vueSlider,
  },

  mixins: [FieldMixin],
};
</script>
